module.exports = [
  {
    title: 'Аналитика',
    state: 'Analytics'
  },
  {
    title: 'Статистика',
    state: 'Statistics'
  }
]
